// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class GroupPerson extends TrackingModel {
	public GroupPersonId: number = 0;
	public GroupId: number = 0;
	public PersonId: number = 0;
}